import { Reducer } from 'redux';
import { IAction } from '../types';
import { localKeyInfo } from '../config';
import LocalStore from '@/utils/store';

export interface MsgConfigState {
  msg: string;
  state: number;
  errorMsg: string;
}

const LOCALKEY = localKeyInfo.msgConfig;
const localVoiceInfo = LocalStore.getValue<MsgConfigState>(LOCALKEY) || {};

export const msgConfig: MsgConfigState = {
  msg: '',
  state: 1,
  errorMsg: '',
  ...localVoiceInfo
};

export const setMsgConfig: (payload: MsgConfigState) => IAction<MsgConfigState> = (payload: MsgConfigState) => ({
  type: 'setMsgConfig',
  payload
});

const msgConfigReducer: Reducer<MsgConfigState, IAction<any>> = (state = msgConfig, action: IAction<any>) => {
  const { type, payload } = action;
  switch (type) {
    case 'setMsgConfig':
      LocalStore.setValue(LOCALKEY, payload);
      return {
        ...payload
      };
    default:
      return state;
  }
};

export default msgConfigReducer;
